import React from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import auth, { LoginDialog } from '@ifeng-fe/ui_pc_auth';

/**
 * for this page
 */
// import Content from './content/';

class LoginBtn extends React.PureComponent {
    static propTypes = {
        configClass: PropTypes.string,
        txt: PropTypes.string,
        openModal: PropTypes.func
    };

    state = {
        noPhoneNum: false,
    };

    unBindLogin = null;
    loginId = auth.uuid();
    // 登录

    ref = React.createRef();

    // 关闭弹窗的校验

    render() {
        /**
         * 组件分发数据
         */
        const { configClass, txt } = this.props;
        const { href } = this.state;

        return (
            <React.Fragment>
                <div className={configClass} onClick={this.props.openModal}>
                    {txt}
                </div>
                <LoginDialog id={this.loginId} />
                <span href={href} style={{ display: 'none' }} />
            </React.Fragment>
        );
    }
}

export default errorBoundary(LoginBtn);
